import '../Tutorial.css';
import React, {useState} from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";
import {useActions} from "../../../hooks/useActions";
import Hole from "../Hole";

function T37ShowResOnCard() {
    const {setTutorial} = useActions();
    const [showNext, setShowNext] = useState(false);
    const atEnd = () =>{
        setShowNext(true);
    }

    const text = 'All cards have a mana cost required to play them';

    return (
        <div>
            <Hole className={'.playerHand .playerHandItem:first-of-type .manaCost'} diameter={230} />
            <div className='ShowRes35'>
            </div>


            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialTopContainerShoRes35'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start().callFunction(atEnd);
                    }}
                /></div>
                {(showNext)?
                    <div className={'tutorialButton defaultButtonAnimation'} onClick={() => {
                        setTutorial({isActive: true, step: 'PlayFirstCard40'});
                    }}>
                    </div>
                    : <div className={'tutorialButtonPlaceholder'}></div>
                }
            </div>
        </div>

    );
}

export default T37ShowResOnCard;
